module.exports = __webpack_public_path__ + "img/logo57.a2f395a8.png";